import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import ability from '@/libs/ability'

Vue.use(abilitiesPlugin, ability)
